<template>
  <div>
    <v-app id="inspire">
      <div class="fd-auth-bg">
        <v-layout wrap justify-center fill-height style="min-height:100vh">
          <v-flex xs11 sm10 md8 lg7 px-2 align-self-center>
            
            <v-snackbar v-model="showSnackBar" color="black" right :timeout="timeout">
              <v-layout wrap justify-center>
                <v-flex text-left class="align-self-center">
                  <span style="color: white">{{ msg }}</span>
                </v-flex>
                <v-flex text-right>
                  <v-btn small :ripple="false" text @click="showSnackBar = false">
                    <v-icon style="color: white">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-snackbar>

            <v-layout wrap justify-center align-stretch>
              <!-- LEFT: Branding panel -->
              <v-flex sm6 md6 lg6 hidden-xs-only d-flex>
                <v-card outlined class="pa-4 fd-auth-panel" style="border-radius: 0px; width: 100%; height: 100%;">
                  <v-layout wrap justify-center fill-height pt-16>
                    <v-flex xs12 class="fill-height">
                      <v-layout wrap justify-center align-self-center>
                        <!-- Logo with white frosted card to neutralise beige box -->
                        <v-flex xs8 sm6 md5 class="text-center">
                          <div class="fd-logo-card">
                            <v-img
                              src="../../assets/Images/logowhite.png"
                              contain
                              max-height="80px"
                            ></v-img>
                          </div>
                        </v-flex>

                        <v-flex xs12 class="text-center" pt-5>
                          <span class="fd-auth-brand-title">ECOFRAME</span>
                        </v-flex>
                        <v-flex xs12 class="text-center" pt-3>
                          <span class="fd-auth-brand-sub">Your Gateway to Nature's Canvas</span>
                        </v-flex>
                        <v-flex xs10 class="text-center" pt-6>
                          <span class="fd-auth-brand-desc">
                            Kerala Forest Department
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <!-- RIGHT: Form panel -->
              <v-flex xs12 sm6 md6 lg6 d-flex>
                <v-card outlined class="pa-5 fd-form-card" style="border-radius: 0px; width: 100%; height: 100%;">
                  <v-layout wrap justify-center align-center fill-height>
                    <v-flex>
                      <v-layout wrap justify-center>

                        <v-flex xs12 pt-6 pb-2>
                          <v-layout wrap justify-center>
                            <v-flex xs10 text-start>
                              <span class="fd-form-title">IB Booking</span>
                            </v-flex>
                            <v-flex xs10 pt-1 pb-4>
                              <span class="fd-form-subtitle">Log In</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs10 pt-2>
                          <div class="fd-auth-input">
                            <v-form @submit.prevent="validateInput">
                              <v-text-field
                                color="#15803d"
                                label="User Name"
                                outlined
                                dense
                                style="font-family: Inter, sans-serif"
                                v-model="username"
                                hide-details
                              ></v-text-field>
                            </v-form>
                          </div>
                        </v-flex>

                        <v-flex xs10 pt-4>
                          <div class="fd-auth-input">
                            <v-form @submit.prevent="validateInput">
                              <v-text-field
                                color="#15803d"
                                label="Password"
                                outlined
                                dense
                                type="password"
                                style="font-family: Inter, sans-serif"
                                v-model="password"
                                hide-details
                              ></v-text-field>
                            </v-form>
                          </div>
                        </v-flex>

                        <v-flex pt-5 pb-8 xs10>
                          <v-btn
                            class="no-uppercase mainfont"
                            dark
                            block
                            color="#15803d"
                            :loading="loading"
                            :disabled="loading"
                            @click="validateInput"
                            style="height:44px; font-size:15px; font-weight:600; letter-spacing:0.5px;"
                          >
                            <span>CONTINUE</span>
                          </v-btn>
                        </v-flex>

                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

            </v-layout>

            <!-- Footer -->
            <v-flex xs12 class="text-center" pt-4>
              <span style="font-size: 11px; color: rgba(255,255,255,0.55); font-family: 'Inter', sans-serif;">
                ©{{ new Date().getFullYear() }} Kerala Forest Department — All rights reserved
              </span>
            </v-flex>

          </v-flex>
        </v-layout>
      </div>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import store from "./../../store";
export default {
  data() {
    return {
      loading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      otp: null,
      phone: null,
      username: null,
      password: null,
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
  },
  methods: {
    validateInput() {
      if (this.loading) return;
      if (!this.username) {
        this.msg = "Please Provide OTP";
        this.showSnackBar = true;
        return;
      } else {
        this.login();
      }
    },
    login() {
      this.loading = true;
      axios({
        method: "post",
        url: "/login/",
        data: {
          username: this.username,
          password: this.password,
        },
      })
        .then((response) => {
          store.commit("appLoading", false);
          if (response.data.status) {
            store.commit("loginUser", response.data.token);
            // The router sends a signed-in user on /login to their role's home page.
            this.$router.push({ path: "/login" });
          } else {
            this.loading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
   
<style>
.mainbg {
  background-image: linear-gradient(269.6deg, #29807c -31.66%, #29807c);
}

/* Logo wrapper — white frosted pill to isolate any image bg artifacts */
.fd-logo-card {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  padding: 16px;
  display: inline-block;
  width: 100%;
  backdrop-filter: blur(4px);
}

/* Branding text */
.fd-auth-brand-title {
  font-size: 26px;
  font-weight: 700;
  color: #ffffff !important;
  font-family: "Inter", sans-serif;
  letter-spacing: 1px;
  text-shadow: 0 1px 8px rgba(0,0,0,0.3);
}

.fd-auth-brand-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.82) !important;
  font-weight: 300;
  font-family: "Inter", sans-serif;
}

.fd-auth-brand-desc {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.55) !important;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  line-height: 1.7;
}

/* Form title */
.fd-form-title {
  font-family: "Inter", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #14532d;
}

.fd-form-subtitle {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #6b7280;
}

/* Green-tinted input borders (scoped to auth pages) */
.fd-auth-input .v-text-field--outlined fieldset {
  border-color: #a7f3d0 !important;
  transition: border-color 0.2s ease;
}
.fd-auth-input .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #15803d !important;
  border-width: 2px !important;
}
</style>